import { Icons, Table, Tooltip } from '@cambridgeassessment/cambridge-ui';
import { AlgoRerunDto, RerunReasonsEnum } from '@cambridgeassessment/lib-ee-commons';
import React, { useState } from 'react';
import { resolveSortOrder, sortAlgoRerunTable, SortTypes, TableSortConfig } from '../helpers';
import { StyledParagraph, TitleIconWrapper } from '../ManageSampleChanges.styles';
import { resolveRerunReasonText } from './helpers';

interface Props {
  rerunsData: AlgoRerunDto[];
}

export const AlgoRerunAuditTable = (props: Props): JSX.Element => {
  const { rerunsData } = props;

  const [sortConfig, setSortConfig] = useState<TableSortConfig>();

  sortAlgoRerunTable(rerunsData, sortConfig);

  const resolveReasonStr = (item: AlgoRerunDto) => {
    if (item.type === RerunReasonsEnum.OTHER && item.otherReason != null) {
      const MAX_WORDS_COUNT = 6;
      const MAX_CHAR_COUNT = 50;

      const words = item.otherReason.split(' ');
      const isTooLong = words.length > MAX_WORDS_COUNT || item.otherReason.length > MAX_CHAR_COUNT;
      const reasonStr = isTooLong ? `${words?.splice(0, MAX_WORDS_COUNT).join(' ')}...` : item.otherReason;

      return isTooLong ? (
        <Tooltip placement='bottom-end' title={`Other: ${item.otherReason}`} arrow dataQaId='reason-tooltip'>
          <div>Other: {reasonStr}</div>
        </Tooltip>
      ) : (
        <div>Other: {reasonStr}</div>
      );
    } else {
      return <div>{resolveRerunReasonText(item.type)}</div>;
    }
  };

  return (
    <div>
      <StyledParagraph>Audit history for re-run sampling selections</StyledParagraph>
      <Table<AlgoRerunDto>
        data={rerunsData}
        columns={[
          {
            renderHeaderCell: function render() {
              return (
                <TitleIconWrapper>
                  <div data-qa-id={'date-time-header-cell'}>Date and time</div>
                  <Icons.Arrows selected={sortConfig?.sortField === SortTypes.Date} />
                </TitleIconWrapper>
              );
            },
            renderCell: function render(item) {
              return <div>{item.dateOfRerun}</div>;
            },
            onHeaderClick: () => {
              resolveSortOrder(SortTypes.Date, setSortConfig, sortConfig);
            },
          },
          {
            renderHeaderCell: function render() {
              return (
                <TitleIconWrapper>
                  <div data-qa-id={'user-name-header-cell'}>User name</div>
                  <Icons.Arrows selected={sortConfig?.sortField === SortTypes.Username} />
                </TitleIconWrapper>
              );
            },
            renderCell: function render(item) {
              return <div>{item.user}</div>;
            },
            onHeaderClick: () => {
              resolveSortOrder(SortTypes.Username, setSortConfig, sortConfig);
            },
            align: 'left',
          },
          {
            renderHeaderCell: function render() {
              return (
                <TitleIconWrapper>
                  <div data-qa-id={'reason-header-cell'}>Reason for re-run</div>
                  <Icons.Arrows selected={sortConfig?.sortField === SortTypes.Reason} />
                </TitleIconWrapper>
              );
            },
            renderCell: function render(item) {
              return resolveReasonStr(item);
            },
            onHeaderClick: () => {
              resolveSortOrder(SortTypes.Reason, setSortConfig, sortConfig);
            },
            align: 'right',
          },
        ]}
      />
    </div>
  );
};
